export interface ChangelogEntry {
  id: string;
  date: string; // YYYY-MM-DD
  changeKeys: string[];
}

export const CHANGELOG_ENTRIES: ChangelogEntry[] = [
  {
    id: "2026-02-25-3d-spigot-door-rendering",
    date: "2026-02-25",
    changeKeys: [
      "update3DSpigotModel",
      "update3DSpigotOrientationAndScale",
      "update3DGlassSeatHeight",
      "update3DDoorPanelFix",
    ],
  },
  {
    id: "2026-02-14-editable-attachment-quantities",
    date: "2026-02-14",
    changeKeys: ["updateEditableQuantities"],
  },
];
